import $ from 'jquery'
import SVGInjector from 'svg-injector'

class InjectSvg {
  constructor(selector = 'img.inject-svg') {
    this.items = $(selector)
    this.init()
  }

  init() {
    this.items.each((index, item) => {
      const focusableAttr = item.getAttribute('focusable')

      SVGInjector(item, {
        each: function(svg) {
          svg.ariaHidden = item.ariaHidden
          if (!focusableAttr) {
            return
          }
          svg.setAttribute('focusable', focusableAttr)
        },
      })
    })
  }
}

export default InjectSvg
